import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  printFile: [],
  ripsFile:[],
  data:{},
  image:null
};


const printSlice = createSlice({
    name: "print",
    initialState,
    reducers: {
        getAllPrintFile(state, action){
            state.loading = false;
            state.printFile = action.payload;
            state.loading = true;
        },
        getAllRipsForChart(state, action){
          state.loading = false;
          state.ripsFile = action.payload;
          state.loading = true;
      },
      loading(state, action) {
        state.loading = action.payload;
      },
    },
  });

  export default printSlice.reducer;
  export const {
    getAllPrintFile,
    getFalsePrintFile,
    getAllRipsForChart,
    loading,
    loadingFal,
  } = printSlice.actions;